export default __webpack_public_path__ + "static/media/miguel-lopes-44.e8753562.jpg";